import React from 'react';
import LessonShell from '../../../Components/LessonShell';
import { activityThemes } from '../../../Components/LessonActivityCard';
import RelatedExercises from '../../../Shared/relatedExercises';
import ExerciseRouter from './exercise-router';
import './grammar-page.css';

/**
 * Grammar lesson adapter.
 *
 * Renders through the same LessonShell as topic lessons, so a grammar page gets
 * the identical hero, step strip, panel and controls. A grammar page is always
 * one explanation plus a list of exercises, which is turned into panels here;
 * the exercise data itself is untouched and still routed by ExerciseRouter.
 */
const GrammarPageLayout = ({
  level,
  title,
  image,
  ExplanationComponent,
  sections,
  seoTitle,
  seoDescription,
  description,
  relatedCategory,
  relatedLevel,
}) => {
  const explanationProps = {
    level,
    title,
    image,
    sections,
    seoTitle,
    seoDescription,
    relatedCategory,
    relatedLevel,
  };

  const panels = [
    {
      label: 'Explanation',
      title: 'Explanation',
      content: ExplanationComponent ? (
        <ExplanationComponent {...explanationProps} />
      ) : (
        <p className="grammar-explanation-missing">
          No explanation has been written for this grammar point yet.
        </p>
      ),
    },

    // Exercises render through the same TopicsSection / ExerciseSection pair
    // topic pages use, so a grammar quiz behaves exactly like a topic quiz.
    ...(sections || []).map((section) => ({
      label: activityThemes[section.type]?.label || section.label || 'Exercise',
      title: section.title || section.label,
      content: (
        <ExerciseRouter type={section.type} subtype={section.id || section.subtype} />
      ),
    })),
  ];

  return (
    <LessonShell
      eyebrow="Grammar"
      title={title}
      image={image}
      level={level}
      description={
        description ||
        'Read the explanation, then practice with the exercises.'
      }
      seoTitle={seoTitle}
      seoDescription={seoDescription}
      seoName="English Exam Exercises"
      panels={panels}
    >
      <RelatedExercises
        currentCategory={relatedCategory}
        currentLevel={relatedLevel}
        currentTitle={title}
      />
    </LessonShell>
  );
};

export default GrammarPageLayout;